window.addEventListener('mediaGallery:slideChange', (e) => {
  const swiper = e.detail?.swiper;
  const productInfo = swiper.el.closest('product-info');
  const viewContext = productInfo.dataset.viewContext;
  const itemName = productInfo.dataset.productName;
  const itemId = productInfo.dataset.productId;
  const itemVariantId = productInfo.dataset.selectedVariantId;
  const imagePosition = swiper.activeIndex + 1; // human readable

  dataLayer.push({
    event: 'select_content',
    event_category: viewContext,
    event_action: 'Alternative Image Swipe',
    event_label: itemName + ' | position ' + imagePosition,
    item_name: itemName,
    item_id: itemId,
    item_variant_id: itemVariantId,
    is_custom_event: true
  });
});

document.addEventListener('quickviewLoadedCart', (e) => {
  if (e.detail) {
    dataLayer.push({
      event: 'edit_details_in_cart',
      item_id: e.detail.product.id,
      item_name: e.detail.product.title,
      item_variant: e.detail.selectedProduct.id, 
      item_list_id: 'cart',
      item_list_name: 'Cart Items'
    });
  }
});

document.addEventListener('quickviewLoaded', (e) => {
  if (window.ElevarDataLayer && e.detail) {
    const list = window.pageType === 'collection' ? '/collections/' + window.pageContext : null;
    window.ElevarDataLayer.push({
      event: "dl_view_item",
      ecommerce: {
        currencyCode: window.Shopify.currency.active,
        detail: {
          actionField: { list: list },
          products: [
            {
              id: e.detail.selectedProduct.sku,
              name: e.detail.product.title,
              brand: e.detail.product.vendor,
              category: "",
              variant: e.detail.selectedProduct.title,
              price: (e.detail.selectedProduct.price / 100).toFixed(2),
              list: list,
              product_id: e.detail.product.id,
              variant_id: e.detail.selectedProduct.id,
              compare_at_price: (e.detail.selectedProduct.compare_at_price  / 100).toFixed(2),
              image: e.detail.selectedProduct.featured_image.src
            }
          ]
        }
      }
    });
  } 
});
